import { type FunctionalComponent, h } from '@stencil/core';
import { ConversationalSearchLabelWithSection } from '../../../../conversational-search-partials/label-with-section/label-with-section';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';
import EventEmitterComponent from '../../../../conversational-search-partials/event-emitter-component/event-emitter-component';

export interface IConversationalSearchFollowUpSatisfiedProps {
  query: string;
  labelProvider: labelProviderInterface;
}

export const ConversationalSearchFollowUpSatisfied: FunctionalComponent<IConversationalSearchFollowUpSatisfiedProps> = (props) => {
    const icon = String.fromCodePoint(128512);
    const ctaText = props.labelProvider(
      'conversational.search.followup.satisfied.new.conversation',
      'start a new topic',
    );

    const introText = props.labelProvider(
      'conversational.search.follow.up.satisfied.intro',
      'Thank you so much!',
    );

    const text = props.labelProvider(
      'conversational.search.follow.up.satisfied',
      'I’m glad I was helpful! Feel free to {1} or continue your conversation here.',
    );

    return (
      <section class="conversational-search-follow-up-satisfied">
        <span>{`${introText} ${icon} `}</span>
        <ConversationalSearchLabelWithSection text={text}>
          <EventEmitterComponent eventName='conversational-search:user-new-conversation-trigger' isNotPropagatedForEnter={true}>
            <EventEmitterComponent EventEmitterComponent eventName='conversational-search:ga-cta' ctaName={'start a new topic'} isNotPropagatedForEnter={true} keyword={props.query}>
              <qds-inline-link>{ctaText}</qds-inline-link>
            </EventEmitterComponent>
          </EventEmitterComponent>
        </ConversationalSearchLabelWithSection>
      </section>
    );
};
